// extracted by mini-css-extract-plugin
export default {"container":"MenuDialog_container__t1uRs","menuDialog":"MenuDialog_menuDialog__46nQA","menuDialogMobile":"MenuDialog_menuDialogMobile__4uVQY","close":"MenuDialog_close__BmaUs"};